import { render, staticRenderFns } from "./AssociacaoSindicatoNaoEmprestimoForm.vue?vue&type=template&id=2c72aa81&scoped=true&"
import script from "./AssociacaoSindicatoNaoEmprestimoForm.vue?vue&type=script&lang=js&"
export * from "./AssociacaoSindicatoNaoEmprestimoForm.vue?vue&type=script&lang=js&"
import style0 from "./AssociacaoSindicatoNaoEmprestimoForm.vue?vue&type=style&index=0&id=2c72aa81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c72aa81",
  null
  
)

export default component.exports